import * as actionTypes from '../actionTypes'

export const supportWidgetOpen = () => (dispatch) => {
  dispatch({ type: actionTypes.SUPPORT_WIDGET_OPEN })
}
export const supportWidgetClose = () => (dispatch) => {
  dispatch({ type: actionTypes.SUPPORT_WIDGET_CLOSE })
}
